<template>
  <div class="login_container">
    <!-- 登录头部 -->
    <div class="login_header w_d">
      <div class="header_box">
        <img src="@/assets/images/项目成果首页03/logo.png" alt="" />
        <!-- <div class="logo_title">
          <h3>XX市能力提升工程2.0</h3>
          <p>项目成果共建共享平台</p>
        </div> -->
        <div class="line"></div>
        <h2>欢迎登录</h2>
      </div>
      <div class="header_r pointer" v-if="showForget" @click="triggerLogin">
        <img src="@/assets/images/登录界面/立即登录icon.png" alt="" />
        <span>立即登录</span>
      </div>
    </div>
    <!-- main -->
    <!-- 忘记密码 -->
    <ForgetPwd v-if="showForget" @triggerLogin="triggerLogin"></ForgetPwd>
    <!-- 登录开始 -->
    <div class="login_bg" v-else>
      <div class="login_box">
        <div class="login_title">
          <h3
            @click="acountPwdClick"
            :class="{ tabs_current: triggerTabs == 1 }"
            class="pointer pass_hand"
          >
            账号密码登录
          </h3>
          <h3
            @click="phoneClick"
            :class="{ tabs_current: triggerTabs == 2 }"
            class="pointer pass_hand"
          >
            手机快捷登录
          </h3>
        </div>
        <div class="both_content">
          <!-- <LoginForm v-if="triggerTabs == 1" :phObj="phObj1"></LoginForm>
          <LoginForm v-if="triggerTabs == 2" :phObj="phObj2"></LoginForm> -->
          <!-- 账号密码登录 -->
          <transition name="slide-left">
            <div class="count_content" v-if="triggerTabs == 1">
              <el-form
                :model="loginForm"
                status-icon
                :rules="rules"
                ref="loginForm"
                class="demo-ruleForm"
              >
                <el-form-item prop="acount" class="acount_item">
                  <!-- 账号 -->
                  <div>
                    <img
                      src="../../assets/images/登录界面/用户icon.jpg"
                      alt=""
                    />
                  </div>
                  <el-input
                    type="text"
                    v-model="loginForm.acount"
                    placeholder="手机/身份证"
                    class="user_input"
                  ></el-input>
                </el-form-item>
                <!-- 密码 -->
                <el-form-item prop="password" class="pwd_item ppp">
                  <div>
                    <img
                      src="../../assets/images/登录界面/密码icon.jpg"
                      alt=""
                    />
                  </div>
                  <el-input
                    type="password"
                    v-model="loginForm.password"
                    autocomplete="off"
                    placeholder="密码"
                    class="user_input"
                  >
                  </el-input>
                </el-form-item>
                <!-- 滑动条 -->
                <el-form-item prop="verifySuccess">
                  <div class="login_slider">
                    <Slider v-model="loginForm.verifySuccess"></Slider>
                  </div>
                </el-form-item>
                <div class="auto_forget">
                  <el-checkbox v-model="autoLogin">两周内自动登录</el-checkbox>
                </div>
                <el-form-item class="login_item">
                  <el-button class="pointer" @click="userLogin('loginForm')"
                    >登录</el-button
                  >
                </el-form-item>
                <div class="auto_forget">
                  <span class="pointer pass_hand" @click="goToForgetPage(1)"
                    >注册新用户</span
                  >
                  <span class="pointer pass_hand" @click="goToForgetPage(2)"
                    >忘记密码?</span
                  >
                </div>
              </el-form>
            </div>
          </transition>
          <!-- 手机快捷登录 -->
          <transition name="slide-left">
            <div class="count_content" v-if="triggerTabs == 2">
              <el-form
                :model="phoneForm"
                status-icon
                :rules="rules"
                ref="ruleForm"
                class="demo-ruleForm"
              >
                <el-form-item prop="phone" class="acount_item">
                  <!-- 手机号 -->
                  <div>
                    <img
                      src="../../assets/images/登录界面/用户icon.jpg"
                      alt=""
                    />
                  </div>
                  <el-input
                    type="text"
                    v-model="phoneForm.phone"
                    autocomplete="off"
                    placeholder="手机号码"
                    class="user_input"
                  ></el-input>
                </el-form-item>
                <!-- 验证码 -->
                <el-form-item prop="veriCode" class="pwd_item">
                  <div class="bao">
                    <div>
                      <img
                        src="../../assets/images/登录界面/密码icon.jpg"
                        alt=""
                      />
                    </div>
                    <el-input
                      type="text"
                      v-model="phoneForm.veriCode"
                      autocomplete="off"
                      placeholder="验证码"
                      class="user_input"
                    >
                    </el-input>
                  </div>
                  <div class="getCode pointer pass_hand" @click="getPhoneCode">
                    {{ codeText }}
                  </div>
                </el-form-item>
                <!-- 滑动条 -->
                <el-form-item prop="verifySuccess">
                  <div class="login_slider">
                    <Slider v-model="phoneForm.verifySuccess"></Slider>
                  </div>
                </el-form-item>

                <div class="auto_forget">
                  <el-checkbox v-model="autoLogin">两周内自动登录</el-checkbox>
                </div>
                <el-form-item class="login_item">
                  <el-button class="pointer" @click="userLogin('ruleForm')"
                    >登录</el-button
                  >
                </el-form-item>
                <div class="auto_forget">
                  <span class="pointer pass_hand" @click="goToForgetPage(1)"
                    >注册新用户</span
                  >
                  <span class="pointer pass_hand" @click="goToForgetPage(2)"
                    >忘记密码?</span
                  >
                </div>
              </el-form>
            </div>
          </transition>
        </div>
        <!-- 登录底部 -->
        <!-- <div class="login_footer">
          <div class="txt">使用第三方账号登录：</div>
          <img
            class="wx_img"
            src="../../assets/images/登录界面/微信icon.jpg"
            alt=""
          />
          <img src="../../assets/images/登录界面/支付宝icon.jpg" alt="" />
        </div> -->
      </div>
    </div>
    <!-- footer -->
    <footer>
      <ul class="footer_uu">
        <li>首页</li>
        <div class="line"></div>
        <li>法律声明</li>
        <div class="line"></div>
        <li>联系我们</li>
        <!-- <div class="line"></div> -->
        <!--<li>各地办事处</li> -->
        <div class="line"></div>
        <li>项目合作</li>
        <!-- <div class="line"></div> -->
        <!-- <li>招贤纳士</li> -->
      </ul>
      <p>copyright &copy; 华南师范大学 https://www.scnu.edu.cn/ 版权所有</p>
    </footer>
  </div>
</template>

<script>
import ForgetPwd from "../loign/ForgetPwd";
import {
  Login,
  PhoneHasReg,
  GetVericationCode,
  NoteLogin,
} from "../../api/login";
export default {
  data() {
    // 验证手机号
    const rulesloginId = (rule, value, callback) => {
      if (!/^1[34578]\d{9}$/.test(value)) {
        callback("请输入正确的手机号");
      } else {
        callback();
      }
    };
    return {
      triggerTabs: 1, //1为账号密码页,为手机登录页,3为忘记密码页
      loginForm: {}, // 账号密码表单数据对象
      phoneForm: {}, // 账号密码表单数据对象
      rules: {
        acount: [
          {
            required: true,
            message: "请输入手机/邮箱/身份证",
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: rulesloginId, trigger: ["change", "blur"] },
        ],
        verifySuccess: [
          { required: true, message: "请滑动滚动条", trigger: "change" },
        ],
        veriCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      }, // 表单验证规则
      verifySuccess: false, // 滑块验证
      autoLogin: false, // 两周内自动登录
      showForget: false, // false为不显示立即登录并且显示登录页
      countDownNumber: 60, //倒计时时间
      codeText: "获取手机验证码",
      countDownType: false, //false表示可以点击获取验证码
      is_reg: 0, //0表未注册
    };
  },
  methods: {
    // 点击账号密码tabs
    acountPwdClick() {
      this.triggerTabs = 1;
    },
    // 点击手机快捷tabs
    phoneClick() {
      this.triggerTabs = 2;
    },
    // 切换到登录页
    triggerLogin() {
      this.showForget = false;
    },
    // 点击忘记密码
    goToForgetPage(val) {
      localStorage.setItem("loginType", val);
      setTimeout(() => {
        this.showForget = true;
      }, 500);
    },
    // 获取验证码倒计时
    timeDown() {
      let countDownSetInterval = setInterval(() => {
        this.countDownNumber = this.countDownNumber - 1;
        this.codeText = "倒计时" + this.countDownNumber + " 秒";
        this.countDownType = true;
        if (this.countDownNumber == 0) {
          this.countDownType = false;
          this.codeText = "重新发送";
          this.countDownNumber = 60;
          clearInterval(countDownSetInterval);
        }
      }, 1000);
    },
    // 先验证手机是否注册再获取验证码
    getPhoneCode() {
      if (!this.countDownType) {
        PhoneHasReg({
          phone: this.phoneForm.phone,
        }).then((res) => {
          console.log(res);
          this.is_reg = res.data.is_reg;
          if (this.is_reg !== 0) {
            //获取验证码
            GetVericationCode({
              phone: this.phoneForm.phone,
            }).then((res) => {
              console.log(res);
              if (res.data.code == 900) {
                // 倒计时
                this.timeDown();
              }
            });
          }
        });
      }
    },
    // 账号密码登录
    userLogin(loginForm) {
      this.$refs[loginForm].validate((valid) => {
        if (valid) {
          if (this.triggerTabs == 1) {
            // 账号密码登录
            Login({
              account: this.loginForm.acount,
              password: this.loginForm.password,
            })
              .then((res) => {
                // 存取用户信息
                let webUserInfo = res.data;
                webUserInfo.hostOpen = true;
                let hostUrl = window.location.host;
                if (hostUrl == "gjgx.lt-edu.net") {
                  webUserInfo.hostOpen = false;
                }
                localStorage.setItem(
                  "webUserInfo",
                  JSON.stringify(webUserInfo)
                );
                setTimeout(() => {
                  // 重新加载页面
                  location.reload();
                }, 500);
              })
              .catch((err) => {
                console.log(err.response);
              });
          } // 手机登录
          else if (this.triggerTabs == 2) {
            NoteLogin({
              phone: this.phoneForm.phone,
              code: this.phoneForm.veriCode,
            }).then((res) => {
              // 存取用户信息
              let webUserInfo = res.data;
              webUserInfo.hostOpen = true;
              let hostUrl = window.location.host;
              if (hostUrl == "gjgx.lt-edu.net") {
                webUserInfo.hostOpen = false;
              }
              localStorage.setItem("webUserInfo", JSON.stringify(webUserInfo));
              setTimeout(() => {
                // 重新加载页面
                location.reload();
              }, 500);
            });
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {
    // 获取本地信息
    let webUserInfo = {};
    if (localStorage.getItem("webUserInfo")) {
      webUserInfo = JSON.parse(localStorage.getItem("webUserInfo"));
      console.log(webUserInfo);
      if (webUserInfo.client_type == 1) {
        // 跳到市首页
        if (webUserInfo.role == 1) {
          // 微能力教师
          if (webUserInfo.ability_type == 1) {
            // 首次进入个人中心的默认路径
            this.$router.push("/abilityEvaluaList");
            // 非微能力教师
          } else {
            // 首次进入个人中心的默认路径
            this.$router.push("/abilityEvaluaList");
          }
        } else if (webUserInfo.role == 2) {
          // 校培
          this.$router.push("/schooltraindeclare");
          // 县培
        } else if (webUserInfo.role == 3) {
          this.$router.push("/areatrainabilitydclare");
          // 市培
        } else if (webUserInfo.role == 4) {
          this.$router.push("/areatrainabilitydclare");
          // 校管理员
        } else if (webUserInfo.role == 5) {
          // this.$router.push("/schoolmnghome");
          this.$router.push("/abilityevaluation");
        } else {
          this.$message.warning(
            "您的账号还未参加任何学习或教学，请找管理员添加！"
          );
          this.$router.push("/areahome");
        }
        // this.$router.push("/areahome");
      } else if (webUserInfo.client_type == 2) {
        // 跳到区首页
        // 跳到市首页
        if (webUserInfo.role == 1) {
          // 微能力教师
          if (webUserInfo.ability_type == 1) {
            // 首次进入个人中心的默认路径
            this.$router.push("/abilityEvaluaList");
            // 非微能力教师
          } else {
            // 首次进入个人中心的默认路径
            this.$router.push("/abilityEvaluaList");
          }
        } else if (webUserInfo.role == 2) {
          // 校培
          this.$router.push("/schooltraindeclare");
          // 县培
        } else if (webUserInfo.role == 3) {
          this.$router.push("/areatrainabilitydclare");
          // 市培
        } else if (webUserInfo.role == 4) {
          this.$router.push("/areatrainabilitydclare");
          // 校管理员
        } else if (webUserInfo.role == 5) {
          // this.$router.push("/schoolmnghome");
          this.$router.push("/abilityevaluation");
        } else {
          this.$message.warning(
            "您的账号还未参加任何学习或教学，请找管理员添加！"
          );
          this.$router.push("/areahome");
        }
      } else {
        this.$router.push("/areahome");
      }
    } else {
      this.$router.push("/login");
    }
  },
  components: {
    ForgetPwd,
  },
};
</script>
 
<style lang = "less" scoped>
.login_container {
  /* 头部 */
  .login_header {
    height: 88px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .header_r {
      img {
        margin-right: 13px;
        vertical-align: middle;
      }
    }
    .header_box {
      /* position: absolute;
      top: 50%;
      left: 310px;
      transform: translate(0, -50%); */
      display: flex;
      align-items: center;
      > img {
        display: block;
        width: 50px;
      }
      .logo_title {
        margin-left: 20px;
        h3 {
          font-weight: 700;
          font-size: 14px;
          padding-top: 4px;
        }
        p {
          font-size: 12px;
          padding-top: 5px;
        }
      }
      .line {
        width: 1px;
        height: 30px;
        background-color: #999;
        margin: 0 20px;
      }
      > h2 {
        font-weight: 600;
        font-size: 20px;
      }
    }
  }
  /* 修改提示文字大小 */
  /deep/ .el-form-item__error {
    font-size: 14px;
  }
  /* 背景图 */
  .login_bg {
    height: 720px;
    position: relative;
    background: url("../../assets/images/登录界面/banner.jpg") 30% 0% no-repeat;
  }
  /* 登录框 */
  .login_box {
    position: absolute;
    width: 400px;
    height: 540px;
    border-radius: 4px;
    /* border: 1px solid red; */
    top: 78px;
    right: 16%;
    background-color: #fff;
    .login_title {
      width: 288px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 0 29px;
      padding: 42px 0 30px 0;
      h3 {
        font-size: 20px;
        color: #999;
      }
      .tabs_current {
        font-weight: 700;
        color: #333;
      }
    }
    /* 登录内容 */
    .both_content {
      /* padding: 0 29px; */
      /* position: absolute; */
      width: 346px;
      margin: 0 auto;
      overflow: hidden;
      display: flex;
      /* left: 50%;
      top: 50%;
      transform: translate(-50%,-50%); */
      .count_content {
        /deep/ .el-input__inner {
          border: 0;
        }
        .ppp {
          border: 1px solid #dadada;
        }
        .acount_item,
        .pwd_item {
          /deep/ .el-form-item__content {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 342px;
            height: 48px;
            > div {
              img {
                padding-top: 13px;
                margin-left: 17px;
              }
            }
          }
        }
        .acount_item {
          border: 1px solid #dadada;
          /* overflow: hidden; */
        }
        .pwd_item {
          margin-bottom: 18px;
          /deep/ .el-form-item__content {
            width: 344px;
          }
          .getCode {
            width: 140px;
            height: 48px;
            line-height: 48px;
            text-align: center;
            color: #1890ff;
            border: 1px solid #1890ff;
          }
          .bao {
            height: 48px;
            margin-right: 20px;
            display: flex;
            align-items: center;
            border: 1px solid #dadada;
          }
        }
        /* 修改placeholder样式 */
        /deep/.el-input__inner {
          font-size: 16px;
          color: #333;
          &::placeholder {
            color: #999;
            font-size: 16px;
          }
        }
        .login_item {
          .el-button {
            background-color: #fa8c15;
            width: 346px;
            height: 52px;
            font-weight: 600;
            font-size: 20px;
            color: #fff;
            letter-spacing: 6px;
            border: 1px solid #fa8c15;
          }
        }
        .auto_forget {
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          margin: 37px 0 30px 0;
          > span {
            color: #fa8c15;
          }
          .el-checkbox {
            color: #999;
            /deep/ .el-checkbox__inner::after {
              left: 7px;
              top: 3px;
            }
            /deep/ .el-checkbox__inner {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
    /* 登录底部 */
    .login_footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 400px;
      height: 90px;
      background-color: #fef3e7;
      display: flex;
      align-items: center;
      padding-left: 29px;
      .wx_img {
        margin: 0 19px 0 6px;
      }
      img {
        border-radius: 50%;
      }
    }
  }
  /* 底部 */
  footer {
    height: 272px;
    background-color: #f7f7f7;
    font-size: 14px;
    color: #666;
    .footer_uu {
      padding: 62px 0 24px 0;
      width: 541px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .line {
        width: 1px;
        height: 12px;
        margin: 0 21px;
        background-color: #cecece;
      }
    }
    p {
      text-align: center;
    }
  }
}
/* tabs 切换动画 */
.slide-left-enter {
  /* opacity: 0; */
  transform: translate(100%, 0);
}
.slide-left-enter-active {
  transition: all 0.2s linear;
}
.slide-left-leave-to {
  /* opacity: 0; */
  transform: translate(-100%, 0);
}
</style>